import { isPlatformBrowser, Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { ElementRef, Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { AbstractControl, FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { environment } from '@env/environment';
import { ConstantsService } from '@app/services/constants.service';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isoWeek)

import { IDataGenericText, IDataGrouped } from '@app/interfaces/idata-grouped';

declare var $: any;
declare function dropdownInputFilter(): any;
declare function equalHeightGroup(): any;
declare function equalWidthGroup(): any;
declare function cardsSectionWidth(): any;
declare function cardsSectionWidthV2(): any;
declare function btnLabelCollapseControl(): any;
declare function favoriteState(): any;
declare function dropdownCollapseInputFilter(): any;
declare function collapseGroupDropdown(): any;

declare function clearInputDropdown(): any;

declare function accordionGroup(): any;

declare function toAnchor(toLink): any;
declare function verticalNavbarControl(): any;

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  openWhatsappLink(phoneNumber: string, message: string) {

    let urlWhatsapp: string = '';

    if (this.isMobile()) {
      urlWhatsapp = `https://wa.me/`
      urlWhatsapp += phoneNumber;
      urlWhatsapp += `?text=${message}`;
    }
    else {
      urlWhatsapp = `https://web.whatsapp.com/send/?phone=`
      urlWhatsapp += phoneNumber;
      urlWhatsapp += `&text=${message}`;
    }

    window.open(urlWhatsapp, "_blank");
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  isDesktop(): boolean {
    return window.innerWidth > 768;
  }

  removeEmptyFieldsRequest(req: any) {
    // Filtrar el JSON para remover los elementos con un array completamente vacío
    return Object.keys(req).reduce((acc, key) => {

      const value = req[key];

      if ((!Array.isArray(value) && value !== 0 && value !== null && value !== undefined && value !== "") || (Array.isArray(value) && value.length > 0)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }

  getTimeZone(): string {
    return dayjs.tz.guess();
  }


  validateFormControlRequiredValue(arrayForm: UntypedFormControl[]): boolean {

    for (let index = 0; index < arrayForm.length; index++) {
      const element = arrayForm[index];

      if (element.invalid || !element.value) {
        return false;
      }
    }

    return true;
  }



  validateFormControlValue(arrayForm: UntypedFormControl[]): boolean {

    for (let index = 0; index < arrayForm.length; index++) {
      const element = arrayForm[index];

      if (element.invalid) {
        return false;
      }
    }

    return true;
  }

  stringToNumber(value: string): number {

    return parseInt(value.replace(/\D/g, '').replace(/^0+/, ''))
  }




  scrollToTop(timeout: number = 0) {

    setTimeout(() => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, timeout);

  }

  scrollElementToBottom(element: ElementRef<any>) {
    if (element) {
      element.nativeElement.scroll({
        top: element.nativeElement.scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  scrollElementToTop(element: ElementRef<any>) {
    if (element) {
      element.nativeElement.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }



  public findInvalidControls(fg: UntypedFormGroup) {
    const invalid = [];
    const controls = fg.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }


  getMonthName(monthNumber) {
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    return monthNames[monthNumber - 1]

  }

  elementFadeIn(idElement: string) {
    $("#".concat(idElement)).fadeIn();
  }

  elementFadeOut(idElement: string) {
    $("#".concat(idElement)).fadeOut();
  }

  elementCollapseShow(idElement: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(idElement)).collapse('show');
  }

  elementCollapseHide(idElement: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(idElement)).collapse('hide');
  }


  serializeURL(url: string, param: string) {
    return this.router.serializeUrl(this.router.createUrlTree(['/' + url, param]))
  }


  isTesting(): boolean {

    if (environment.testing === true) {
      return true;
    }
    return false;
  }

  isBeta(): boolean {

    if (environment.beta === true || environment.testing === true) {
      return true;
    }
    return false;
  }


  getFakeArray(n: number): any[] {
    return Array(n);
  }


  isProd(): boolean {

    if (environment.production === true) {
      return true;
    }
    return false;
  }

  setLocalStorage(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  getLocalStorage(key: string): string | undefined | any {
    try {
      return localStorage.getItem(key)
    } catch (error) {
      return undefined;
    }
  }

  removeLocalStorage(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.log(error);
    }
  }

  formControlParseInt(f: UntypedFormControl): void {

    if (f.value === '') return;
    try {
      f.setValue(f.value && isNaN(Number(f.value)) === true ? '' : Number(f.value))
    } catch (error) {
      f.setValue('')
    }
  }

  calculateTimeDif(minute: number): string {
    var textReturn = "";


    if (minute < 60) {
      if (minute <= 1) {
        textReturn = minute.toString().concat(" minuto");
      }
      else {
        textReturn = minute.toString().concat(" minutos");
      }
    }
    else if (minute < 1440) {
      var hour = Math.round((minute / 60));
      if (hour <= 1) {
        textReturn = hour.toString().concat(" hora");

      }
      else {
        textReturn = hour.toString().concat(" horas");
      }
    }
    else {
      var day = Math.round((minute / 1440));
      if (day <= 1) {
        textReturn = day.toString().concat(" día");

      }
      else {
        textReturn = day.toString().concat(" días");
      }
    }

    return textReturn;
  }

  toRegisterForm() {
    toAnchor('formulario-registro');
    setTimeout(function () {
      $('.carousel:first form .form-control:first').focus();
    }, 50);
  }



  constructor(
    public datePipe: DatePipe,
    private constantsService: ConstantsService,
    private router: Router,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
  }

  public actionBackButton() {
    this.location.back();
  }



  getRandomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  getScriptJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $.getScript('/js/scripts.js');
  }

  initJsEmployeeBasic() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.dropdown-input-filter .filter-input').keyup(dropdownInputFilter);
    collapseGroupDropdown();
    $('.dropdown-input-tag-collapse .filter-input').keyup(dropdownCollapseInputFilter);
    return true;
  }


  initJsEmployeeFormUpdate() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.nav-tabs-submenu-expand .nav-link-submenu').click(verticalNavbarControl);
    return true;
  }

  collapseGroupDropdownJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    collapseGroupDropdown();
    return true;
  }


  stringToDate(value: any): Date {

    var returnValue: Date;

    try {
      let date = value.split('-');
      let day = parseInt(date[0], 10);
      let month = parseInt(date[1], 10) - 1;
      let year = parseInt(date[2], 10);



      returnValue = new Date(year, month, day);


    } catch {
      returnValue = new Date();
    }

    return returnValue;
  }

  dateDiffHumanize(startdate, enddate): string {

    var dif = this.dateDiff(startdate, enddate);

    if (dif === undefined) return undefined;

    var difyears = "";
    var difmonths = "";
    var difdays = "";
    var countElement = 0;

    if (dif.years > 0) { countElement++; difyears += dif.years + " año" + (dif.years > 1 ? "s" : "") }
    if (dif.months > 0) { countElement++; difmonths += dif.months + " mes" + (dif.months > 1 ? "es" : "") }
    if (dif.days > 0) { countElement++; difdays += dif.days + " día" + (dif.days > 1 ? "s" : "") }

    var strReturn = "";

    if (countElement === 3) {
      strReturn = difyears + ", " + difmonths + " y " + difdays;
    }

    if (countElement === 2) {

      if (difyears.length > 0) {
        strReturn += difyears + " y ";
      }

      if (difmonths.length > 0) {
        strReturn += difmonths + (difyears.length > 0 ? "" : " y ");
      }
      strReturn += difdays;
    }

    if (countElement === 1) {
      strReturn += difyears;
      strReturn += difmonths;
      strReturn += difdays;
    }


    return strReturn;
  }

  dateDiff(startingDate, endingDate) {
    let startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
    if (!endingDate) {
      endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
    }
    let endDate = new Date(endingDate);
    if (startDate > endDate) {
      const swap = startDate;
      startDate = endDate;
      endDate = swap;
    }
    const startYear = startDate.getFullYear();
    const february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
    const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let yearDiff = endDate.getFullYear() - startYear;
    let monthDiff = endDate.getMonth() - startDate.getMonth();
    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }
    let dayDiff = endDate.getDate() - startDate.getDate();
    if (dayDiff < 0) {
      if (monthDiff > 0) {
        monthDiff--;
      } else {
        yearDiff--;
        monthDiff = 11;
      }
      dayDiff += daysInMonth[startDate.getMonth()];
    }

    return {
      years: yearDiff,
      months: monthDiff,
      days: dayDiff
    };


  }

  public getTimeZoneOffsetGuess(): number {
    return dayjs().tz(this.getTimeZone()).utcOffset();
  }


  stringToMSQLDate(value: any): string {

    var returnValue: string;

    try {
      returnValue = this.datePipe.transform(this.stringToDate(value), 'yyyy-MM-dd');

    } catch (err) {
      returnValue = '';
    }

    return returnValue;
  }

  dateMaterialToMSQLDate(value: any): string {

    var returnValue: string;

    try {
      returnValue = this.datePipe.transform(value, 'yyyy-MM-dd')

    } catch (err) {
      returnValue = '';
    }

    return returnValue;
  }




  dateToMSQLDate(value: Date): string {

    var returnValue: string;

    try {
      returnValue = this.datePipe.transform(value, 'yyyy-MM-dd');

    } catch (err) {
      returnValue = '';
    }

    return returnValue;
  }

  downloadJsonToCSV(res: any, filename: string) {
    var json = res
    var fields = Object.keys(json[0])
    var replacer = function (key, value) { return value === null ? '' : value }
    var csv = json.map(function (row) {
      return fields.map(function (fieldName) {
        return JSON.stringify(row[fieldName], replacer)
      }).join(',')
    })
    csv.unshift(fields.join(',')) // add header column
    csv = csv.join('\r\n');

    let now = new Date();
    var blob = new Blob(["\uFEFF" + csv], { type: 'text/csv; charset=utf-18' })
    saveAs(blob, filename + " - " + now.toLocaleDateString() + " " + now.toLocaleTimeString() + ".csv");
  }


  navigateToLoginAdvice(_idJob) {
    this.router.navigate(['/' + this.constantsService.BASE_PATH_LOGIN_EMPLOYEE], { queryParams: { returnUrl: this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_JOB_VIEW, _idJob]) } });
    return true;
  }

  navigateToLoginResumeInstitution(_idInstitution) {
    this.router.navigate(['/' + this.constantsService.BASE_PATH_LOGIN_EMPLOYEE], { queryParams: { returnUrl: this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_EMPLOYEE_RESUME_SEND, "institucion-" + _idInstitution]) } });
    return true;
  }


  navigateToLoginResume() {
    this.router.navigate(['/' + this.constantsService.BASE_PATH_LOGIN_EMPLOYEE], { queryParams: { returnUrl: this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_EMPLOYEE_RESUME_SEND]) } });
    return true;
  }


  navigateToRegisterAdvice(_idJob) {
    this.router.navigate(['/' + this.constantsService.BASE_PATH_EMPLOYEE_BASIC], { queryParams: { returnUrl: this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_JOB_VIEW, _idJob]) } });
    return true;
  }

  navigateToRegisterResume(_idInstitution) {
    this.router.navigate(['/' + this.constantsService.BASE_PATH_EMPLOYEE_BASIC], { queryParams: { returnUrl: this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_EMPLOYEE_RESUME_SEND, "institucion-" + _idInstitution]) } });
    return true;
  }

  navigateToEmployeeEdit(_idJob) {
    this.router.navigate(['/' + this.constantsService.BASE_PATH_EMPLOYEE_EDIT], { queryParams: { returnUrl: this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_JOB_VIEW, _idJob]) } });
    return true;
  }

  createUrlTree(arr: Array<any>) {
    return this.router.createUrlTree(arr);
  }


  toAnchor(toLink) {
    var toAnchor = $("a[name='" + toLink + "']");
    $('html,body').animate({ scrollTop: toAnchor.offset().top }, 450);
  }

  navigateToJobView(id: any, isPreviousHome: boolean = false) {

    var url = undefined;

    if (isPreviousHome) {
      url = this.router.serializeUrl(this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_JOB_VIEW, id], { queryParams: { returnUrl: 'home' } }));
    }
    else {
      url = this.router.serializeUrl(this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_JOB_VIEW, id]))
    }

    window.open(url, '_blank');
  }

  navigateToEmployeeProfile() {

    var url = this.router.serializeUrl(this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_EMPLOYEE_EDIT]))

    window.open(url, '_blank');
  }


  navigateToJobNew() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/' + this.constantsService.BASE_PATH_JOB, 'nuevo']))

    window.open(url, '_blank');
  }

  goToLink(url: string) {
    console.log(url);

    if (!/^https?:\/\//i.test(url)) {
      url = 'http://' + url;
    }

    window.open(url, "_blank");
  }


  showModalTab(modal: string, tab: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('#' + modal + ' a[href="#' + tab + '"]').tab('show');
  }

  modalShow(modalName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $("#" + modalName).modal('show');
  }

  modalHide(modalName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $("#" + modalName).modal('hide');
  }

  modalShowChilden(parent: string, children: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $(`#${parent}`).on('hidden.bs.modal', function () {
      $(`#${children}`).modal('show');
      $(`#${parent}`).off('hidden.bs.modal')
    });
    $(`#${parent}`).modal('hide');
  }


  showTab(tab: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('a[href="#' + tab + '"]').tab('show');
  }

  initCustomDisabledEvents() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.custom-disabled-events').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  initPreventDefaultEvents() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.prevent-default-btn').click(function (e) {
      e.preventDefault();
    });
  }

  initJsPopover() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    setTimeout(() => {
      $(function () {
        $('[data-toggle="popover"]').popover({ boundary: 'window', html: true });
      });
    }, 100);
  }

  getDecryptFileEmployeeResume(str: any) {
    return "https://firebasestorage.googleapis.com/v0/b/" + environment.firebase.storageBucket + "/o/" + "employee%2Fresume%2F" + str + "?alt=media";
  }

  getDecryptFileCourseProgram(str: any) {
    return "https://firebasestorage.googleapis.com/v0/b/" + environment.firebase.storageBucket + "/o/" + "course%2Ffiles%2F" + str + "?alt=media";
  }



  initFilterInputJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('.filter-input').keyup(dropdownInputFilter);
  }

  initFilterInputClearJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('.dropdown-input-filter').on('hidden.bs.dropdown', clearInputDropdown);
  }

  equalHeightGroupJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('.equal-height-group').each(equalHeightGroup);
  }

  equalWidthGroupJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('.equal-width-group').each(equalWidthGroup);
  }

  initJsAccordionGroup() {

    setTimeout(() => {
      $('.accordion-group').each(accordionGroup);
    }, 100);
  }

  initJsAccordionGroupFistOpen() {

    setTimeout(() => {
      $('.accordion-group').each(accordionGroup);
      $('.accordion-group .card:first .card-header a').trigger('click');
    }, 150);
  }


  //custom event to be called when the html is loaded dinamocally
  enableActionClickRotateArrow(className: string) {
    $('.' + className).click(function () {
      $(this).find('.pj-ico').not($(this).find('.pj-ico')).addClass('rotate-0').removeClass('rotate-180-againts-clockwise');
      $(this).find('.pj-ico').toggleClass('rotate-0 rotate-180-againts-clockwise');
    });
    return true;
  }


  accordionGroup(idElement: string, prefix: string, openFirstElement: boolean = true) {

    var collapse = $("#" + idElement).find('.card .collapse');
    var headerLink = $("#" + idElement).find('.card .card-header a');

    collapse.each(function (i) {
      $(this).attr('id', prefix + 'collapse-' + [i]);
    });

    headerLink.each(function () {
      var thisCollapseId = $(this).closest('.card').find('.collapse').attr('id');
      $(this).closest('.card').find('.card-header a').attr('href', '#' + thisCollapseId);
      $(this).closest('.card').find('.card-header a').attr('aria-controls', thisCollapseId);
    });

    headerLink.click(function () {
      $(this).closest('.accordion-group').find('.collapse').collapse('hide');
      $(this).closest('.accordion-group').find('.rotate-180-againts-clockwise').not($(this).find('.pj-ico')).removeClass('rotate-180-againts-clockwise');
    });

    if (openFirstElement) {
      $("#" + idElement).find('.accordion-group .card:first-child .card-header a').trigger('click');
    }

  }



  accordionGroupReset(idElement: string) {

    if ($("#" + idElement).find('.accordion-group .card:first-child .card-header i').hasClass('rotate-180-againts-clockwise') === false) {
      $("#" + idElement).find('.accordion-group .card:first-child .card-header a').trigger('click');
    }
  }




  initJsLandingFaq() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('.accordion-group').each(accordionGroup);
  }

  initJsLandingPremium() {
    $('.equal-height').each(equalHeightGroup);
    $(window).resize(function () { $('.equal-height').each(equalHeightGroup); });
    $('.accordion-group').each(accordionGroup);
  }

  initJsHomePremium() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.getScriptJs();
    $('.equal-height-group').each(equalHeightGroup);

    $('.equal-height').each(equalHeightGroup);
    $(window).resize(function () { $('.equal-height').each(equalHeightGroup); });
    $('.accordion-group').each(accordionGroup);
    $('.filter-input').keyup(dropdownInputFilter);
    $('.dropdown-input-filter').on('hidden.bs.dropdown', clearInputDropdown);

    $(window).resize(function () {
      $('.equal-height-group').each(equalHeightGroup);
    });
  }




  initJsSearchTalent() {
    $('.equal-height-group').each(equalHeightGroup);
    $('.equal-width-card-v2').each(cardsSectionWidthV2);
    $('.btn-collapse-control').each(btnLabelCollapseControl);
    $('.favorite-applicant-option .input').each(favoriteState);
    $('.dropdown-input-tag-collapse .filter-input').keyup(dropdownCollapseInputFilter);
    collapseGroupDropdown();
  }



  cardsSectionWidthJs() {
    cardsSectionWidth()
    return true;
  }

  closeModalKanban(job: any) {

    job.jobCountSentNew = 0;
    job.jobCountInvitationAccepted = 0;
    job.jobCountSent = $('#cardGroup1').find('.drag-card').length;
    job.jobCountDiscard = $('#cardGroup2').find('.drag-card').length;
    job.jobCountSelected = $('#cardGroup3').find('.drag-card').length;
    job.jobCountForInterviewing = $('#cardGroup4').find('.drag-card').length;
    job.jobCountHired = $('#cardGroup5').find('.drag-card').length;
  }

  getArrayPagination(actualpage: number, recordsCount: number, recordsPerPage: number): any[] {

    var arr = [];

    var lastpage = Math.ceil(recordsCount / recordsPerPage);
    var insertItem = 0;

    if (actualpage > 1) {
      arr.push({ page: 1, label: '«', title: 'Primero', active: false });
      arr.push({ page: actualpage - 1, label: '⟨', title: 'Anterior', active: false });
    }



    var customPage = actualpage - 2;
    if (customPage < 1) { customPage = 1 };

    var maxPage = customPage + 4;
    if (lastpage < maxPage) maxPage = lastpage;

    while (maxPage - customPage < 4) {
      if (customPage - 1 > 0) {
        customPage--;
      }
      else {
        break;
      }
    }


    for (let index = customPage; index <= maxPage; index++) {

      if (index === actualpage) {
        arr.push({ page: index, label: index, active: true });
      }
      else {
        arr.push({ page: index, label: index, active: false });
      }
      insertItem++;
    }

    if (actualpage < lastpage) {
      arr.push({ page: actualpage + 1, label: '⟩', title: 'Siguiente', active: false });
      arr.push({ page: lastpage, label: '»', title: 'Último', active: false });
    }


    if (insertItem > 0) {
      return arr;
    }
    {
      return [];
    }
  }

  showToastSuccess() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $(".toast-success").toast({ autohide: true, delay: 3000 }),
      $(".toast-success").toast("show")
  }

  showToastError() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.toast-danger:not(.toast-danger-priority)').toast({ autohide: true, delay: 3000 });
    $('.toast-danger:not(.toast-danger-priority)').toast('show');
  }

  /* triggered when the schooll change the employee priority on employee view modal */
  showToastSuccessPriority() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $(".toast-success-priority").toast({ autohide: true, delay: 3000 }),
      $(".toast-success-priority").toast("show")
  }


  showToastSuccesLinkValidation() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $(".toast-success-link-validation").toast({ autohide: true, delay: 3000 }),
      $(".toast-success-link-validation").toast("show")
  }

  showToastSuccessCustomMessage() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $(".toast-success-custom-message").toast({ autohide: true, delay: 3000 }),
      $(".toast-success-custom-message").toast("show")
  }



  showToastErrorLinkValidation() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.toast-error-link-validation').toast({ autohide: true, delay: 3000 });
    $('.toast-error-link-validation').toast('show');
  }

  /* triggered when the schooll change the employee priority on employee view modal */
  showToastErrorPriority() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.toast-danger-priority').toast({ autohide: true, delay: 3000 });
    $('.toast-danger-priority').toast('show');
  }





























  matchVimeoUrl(url) {


    if (/^(?:https?:\/\/)?vimeo.com\/\d{8}(?=\b|\/)/.test(url)) {
      return url
    } else {
      return ''
    };
  }






  getFormArrayGender(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectGender.length);
  }

  getFormArrayBenefits(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectBenefit.length);
  }

  getFormArrayTic(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectTic.length);
  }

  getFormArrayBenefitsValues(fa: UntypedFormArray) {
    return fa.value.map((checked, i) => checked ? this.constantsService.dataSelectBenefit[i].name : null).filter(v => v !== null);
  }

  getFormArrayTypeContract(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectTypeContract.length);
  }

  getFormArrayAddress1(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectAddress1List.length);
  }

  getFormArrayAddress3(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectAddress3.length);
  }

  getFormArrayLevel(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectJobLevel.length);
  }

  getFormArrayLevelSalary(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectSalaryLevel.length);
  }


  getFormArrayEmployerType(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectTypeEmployer.length);
  }

  getFormArrayInstitutionEducation(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectInstitutionEducation.length);
  }


  getFormArrayJobStatus(): AbstractControl {
    return this.getFormArrayGeneric(this.constantsService.dataSelectJobStatus.length);
  }

  getFormArrayInstitutionEducationValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectInstitutionEducation)
  }

  getFormArrayJobStatusValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectJobStatus);
  }

  getFormArrayJobModeValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectJobMode);
  }

  getFormArrayEmployerTypeValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectTypeEmployer)
  }

  getFormArrayGenderValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectGender);
  }

  getFormArrayAddress1Values(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectAddress1List)
  }

  getFormArrayAddress3Values(fa: UntypedFormArray) {
    return fa.value.map((checked, i) => checked ? this.constantsService.dataSelectAddress3[i].address3 : null).filter(v => v !== null);
  }

  getFormArrayLevelValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectJobLevel)
  }

  getFormArrayLevelSalaryValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectSalaryLevel)
  }

  getFormArrayTypeContractValues(fa: UntypedFormArray) {
    return this.getFormArrayGenericValues(fa, this.constantsService.dataSelectTypeContract)
  }

  getFormArrayCourseTrainingInstituteValues(fa: UntypedFormArray, arr: Array<any>) {
    return fa.value.map((checked, i) => checked ? arr[i]._id : null).filter(v => v !== null);
  }

  getFormArrayJobUserValues(fa: UntypedFormArray, arr: Array<any>) {
    return fa.value.map((checked, i) => checked ? arr[i]._idUser : null).filter(v => v !== null);
  }

  getFormArrayJobInstitutionValues(fa: UntypedFormArray, arr: Array<any>) {
    return fa.value.map((checked, i) => checked ? arr[i]._id : null).filter(v => v !== null);
  }

  getFormArrayAddress3CustomValues(fa: UntypedFormArray, arr: Array<any>) {
    return fa.value.map((checked, i) => checked ? arr[i].address3 : null).filter(v => v !== null);
  }

  getFormArrayCourseLabelValues(fa: UntypedFormArray, arr: Array<any>) {
    return fa.value.map((checked, i) => checked ? arr[i]._id : null).filter(v => v !== null);
  }

  getFormArrayGenericValues(fa: UntypedFormArray, arr: Array<any>): Array<any> {
    return fa.value.map((checked, i) => checked ? arr[i] : null).filter(v => v !== null);
  }

  getFormArrayGenericTextValues(fa: UntypedFormArray, arr: Array<IDataGenericText>): Array<any> {
    return fa.value.map((checked, i) => checked ? arr[i].text : null).filter(v => v !== null);
  }

  getFormArrayGenericGroupedValues(fa: FormArray, arr: Array<IDataGrouped>): Array<any> {

    const values = [];

    arr.forEach((category, categoryIndex) => {

      const fgCategory = fa.at(categoryIndex) as FormGroup;

      const formArray = (fgCategory.get('items') as FormArray).controls;

      const selectedInCategory = category.items.filter((_, itemIndex) => formArray[itemIndex].value).map(f => { return f.child });

      values.push(...selectedInCategory);
    });

    return values;
  }

  getFormArrayGenericIdValues(fa: UntypedFormArray, arr: Array<IDataGenericText>): Array<any> {
    return fa.value.map((checked, i) => checked ? arr[i].id : null).filter(v => v !== null);
  }

  nextStepCarousel(carouselName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(carouselName)).carousel("next");
  }

  resetStepCarousel(carouselName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(carouselName)).carousel(0);
    $('.form-steps .step').removeClass('ok active');
    $('.form-steps .step:first').addClass('active');
  }
  prevStepCarousel(carouselName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(carouselName)).carousel("prev");
  }

  showStepSuccess(carouselName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(carouselName)).carousel($("#".concat(carouselName, " .successSlide")).index());
    $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
    $('.form-steps .step:last-child').addClass('active').removeClass('ok');
  }


  showStepCarouselByStep(carouselName: string, stepName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $("#".concat(carouselName)).carousel($("#".concat(carouselName, " .".concat(stepName))).index());
    $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
    $('.form-steps .step:last-child').addClass('active').removeClass('ok');
  }

  showStepError(carouselName: string, err: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    console.log(err);
    $("#".concat(carouselName)).carousel($("#".concat(carouselName, " .errorSlide")).index());
    $('.form-steps .step:not(:last-child').addClass('ok').removeClass('active');
    $('.form-steps .step:last-child').addClass('active').removeClass('ok');
  }

  saveAsFileSaver(_filename: string, blob: Blob) {
    saveAs(blob, _filename);
  }

  openBlobNewTab(blob: Blob, fileName: string) {

    // Lista de MIME types que corresponden a archivos PDF
    const pdfMimeTypes = [
      'application/pdf',
      'application/x-pdf',
      'application/acrobat',
      'applications/vnd.pdf',
      'text/pdf',
      'text/x-pdf'
    ];

    if (pdfMimeTypes.includes(blob.type)) {

      // Utilizar FileReader para convertir el Blob a una cadena base64
      const reader = new FileReader();

      reader.onloadend = function () {
        // Obtener la cadena base64 del PDF
        const pdfDataUrl = reader.result;

        // Abrir una nueva pestaña
        const newTab = window.open();

        // Crear el contenido HTML con el PDF incrustado
        let strDocument = `<html><head><title>${fileName}</title></head><body style="margin:0"><embed src="`;
        strDocument += pdfDataUrl;
        strDocument += `" type="application/pdf" width="100%" height="100%" /></body></html>`;

        // Escribir el contenido en la nueva pestaña
        newTab.document.write(strDocument);
        newTab.document.close();
      };

      // Leer el Blob como Data URL (base64)
      reader.readAsDataURL(blob);
    }
    else {
      saveAs(blob, fileName);
    }

  }

  getFormArrayGeneric(length: number): AbstractControl {

    var fa = new UntypedFormArray([]);

    for (let index = 0; index < length; index++) {
      fa.push(new UntypedFormControl(false));
    }

    return fa;
  }


  setFormArrayGeneric(fa: FormArray, length: number) {

    while (fa.controls.length !== 0) {
      fa.removeAt(0, { emitEvent: false })
    }

    for (let index = 0; index < length; index++) {
      fa.push(new FormControl(false), { emitEvent: false });
    }
  }

  setFormArrayGroupGeneric(fa: FormArray, array: Array<IDataGrouped>) {

    array.forEach(parent => {

      var faChild = new FormArray([]);

      parent.items.forEach(child => {
        faChild.push(new FormControl(false));

      });

      fa.push(faChild, { emitEvent: false });
    })
  }


  getFormArrayGroupGenericValues(parent: FormArray, array: Array<IDataGrouped>) {

    const values = [];

    for (let indexParent = 0; indexParent < parent.controls.length; indexParent++) {

      const faParent = parent.at(indexParent) as FormArray;

      for (let indexChild = 0; indexChild < faParent.controls.length; indexChild++) {

        const faControlChild = faParent.at(indexChild) as FormControl;

        if (faControlChild.value === true) {
          values.push(array[indexParent].items[indexChild].id)
        }
      }
    }

    return values;
  }

  getFormArrayGroupGenericLabel(parent: FormArray, array: Array<IDataGrouped>) {

    const values = [];

    for (let indexParent = 0; indexParent < parent.controls.length; indexParent++) {

      const faParent = parent.at(indexParent) as FormArray;

      for (let indexChild = 0; indexChild < faParent.controls.length; indexChild++) {

        const faControlChild = faParent.at(indexChild) as FormControl;

        if (faControlChild.value === true) {
          values.push({ _id: array[indexParent].items[indexChild].id, label: array[indexParent].items[indexChild].child })
        }
      }
    }

    return values;
  }

  setValueFormArrayGeneric(fa: UntypedFormArray, length: number) {
    for (let index = 0; index < length; index++) {
      fa.push(new UntypedFormControl(false), { emitEvent: false });
    }
  }
}